import { render } from "./collect-payment-info.vue?vue&type=template&id=cf029d3a&ts=true"
import script from "./collect-payment-info.vue?vue&type=script&lang=ts"
export * from "./collect-payment-info.vue?vue&type=script&lang=ts"

import "./collect-payment-info.vue?vue&type=style&index=0&id=cf029d3a&lang=css"

import exportComponent from "C:\\Projects\\OnlinePayments\\OnlinePayments\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__